import gql from 'graphql-tag';
import { sessionReportQuestionFieldsFragment } from './sessionReportQuestionFieldsFragment';
import { sessionReportScoreFieldsFragment } from './sessionReportScoreFieldsFragment';

export const sessionReportEvaluationFieldsFragment = gql`
  fragment AdminSessionReportEvaluationFields on SessionReportEvaluation {
    name
    score {
      ...AdminSessionReportScoreFields
    }
    comment
    questions {
      ...AdminSessionReportQuestionFields
    }
  }

  ${sessionReportScoreFieldsFragment}
  ${sessionReportQuestionFieldsFragment}
`;